//
// RendererManagerController.js
// BIRD
//
// Generated by Robots v0.
// Copyright (c) SAS Institute Inc. All rights reserved.
//
// DO NOT EDIT THIS FILE. IT IS GENERATED BY ROBOTS.
//
// Disable camelcase rule for generated code.
/* eslint-disable camelcase */
import { createModule } from "@sas-dvr/ltjs-commons/moduleBuilder";
import EventDispatcher from "@sas-dvr/ltjs-commons/events/EventDispatcher";
import "../../lib";
import "../BIRDModelController";
import "@sas-dvr/ltjs-commons/BaseView";

var RendererManagerController = createModule("BIRD::RendererManagerController", ["BIRD::BIRDModelController"], EventDispatcher, [
    ,
    ,
    ,
    {
        view: 1,
    },
    ,
    ,
    ,
]);
export default RendererManagerController;
